import React from 'react';

import {CompetitionsSliderWidgetProps} from "../models/competitions-slider-widget.props";
import {CompetitionsSliderWidgetDropdown} from "./dropdown/competitions-slider-widget.dropdown";
import {CompetitionsSliderWidgetAllScoresLink} from "./competitions-slider-widget.all-scores-link";

export class CompetitionsSliderWidgetLeftBarProps extends CompetitionsSliderWidgetProps {
}

export const CompetitionsSliderWidgetLeftBar = (({controller, showOdds}: CompetitionsSliderWidgetLeftBarProps) => {
  const {state} = controller;
  return (
    <div className={['competitions-slider-widget-left-bar-container', showOdds && state.hasOdds ? 'competitions-slider-widget-has-odds' : ''].join(' ')}>
      {
        state.allScoresUrl && <CompetitionsSliderWidgetAllScoresLink controller={controller}/>
      }
      <CompetitionsSliderWidgetDropdown controller={controller} selectedCompetitionId={state.selectedCompetitionId}/>
    </div>
  )
});
